import { useTranslation } from '@frontend/i18n';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { NakedButton, Text } from '@frontend/design-system';
import { useAudienceTray } from '../providers/audience-tray-provider';

type Props = {
  handleAddSegment: () => void;
};

export const AddSegmentButton = ({ handleAddSegment, ...rest }: Props) => {
  const { t } = useTranslation('bulk-messaging');
  const { trackingIdPrefix } = useAudienceTray();

  return (
    <NakedButton
      css={{ display: 'flex', marginTop: theme.spacing(1) }}
      onClick={handleAddSegment}
      trackingId={`${trackingIdPrefix}-create-segment-btn`}
      {...rest}
    >
      <Icon name='plus' color='primary' css={{ marginRight: theme.spacing(0.5) }} />
      <Text color='primary'>{t('Create Segment')}</Text>
    </NakedButton>
  );
};
